import React, { useState } from "react";

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Collapse from "@mui/material/Collapse";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { filters, filterVisibilities } from "../assets/filters";
import { IconButton, Typography } from "@mui/material";
import { prettyName } from "../common/prettyName";
import LayerInfo from "../common/LayerInfo";
import { filtersShortDescription } from "../copy/FiltersCopy";

const findFilterDescription = (name) => {
  return filters.find((f) => f.name === name)?.description
}

export default function FiltersCheckboxes({
  setCheckedFilters,
  checkedFilters,
  noFilters,
  setNoFilters,
}) {
  const [collapseOpen, setCollapseOpen] = useState(true);
  const handleChange = (event, name) => {
    setNoFilters(false);
    setCheckedFilters((currentCheckedState) => {
      currentCheckedState[name].visible = event.target.checked;
      return { ...currentCheckedState };
    });
  };

  const handleParentClick = (event) => {
    const checked = event.target.checked;
    setCheckedFilters(filterVisibilities());
    setNoFilters(checked);
    if (!checked) {
      setCollapseOpen(true);
    }
  };

  return (
    <div>
      <FormLabel component="legend">Filters</FormLabel>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <Checkbox checked={noFilters} onChange={handleParentClick} />
        <Typography
          sx={{ cursor: "pointer" }}
          onClick={() => setCollapseOpen(!collapseOpen)}
        >
          Show all
        </Typography>
        <LayerInfo shortDescription={filtersShortDescription} />
        <IconButton onClick={() => setCollapseOpen(!collapseOpen)}>
          {collapseOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={collapseOpen}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            ml: 3,
          }}
        >
          {Object.keys(checkedFilters).map((name, index) => {
            return (
              <Box sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexDirection: "row",
              }}>
                <FormControlLabel
                  key={index}
                  label={prettyName(name)}
                  control={
                    <Checkbox
                      checked={checkedFilters[name].visible}
                      onChange={(event) => handleChange(event, name)}
                    />
                  }
                  sx={{ mr: 0 }}
                />
                <LayerInfo shortDescription={findFilterDescription(name)} />
              </Box>
            );
          })}
        </Box>
      </Collapse>
    </div>
  );
}
